import "@splidejs/react-splide/css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import {
  AiFillHeart,
  AiOutlineClockCircle,
  AiOutlineBorderlessTable,
} from "react-icons/ai";

import Title from "./Title";
import { splideOptions } from "../utils";

const TopStories = ({ data }) => {
  return (
    <div className="nike-container">
      <div className="mb-8">
        <Title title={data.title} />
      </div>
      <Splide options={splideOptions}>
        {data?.news?.map((item, index) => (
          <SplideSlide key={index} className="mb-1">
            <div className="grid items-center relative gap-4 pb-2 rounded shadow shadow-slate-200 ring-1 ring-slate-200">
              <div className="flex items-center justify-center  w-full">
                <img
                  src={item.img}
                  alt={`img/${index}`}
                  className="object-cover w-full h-auto shadow-md shadow-slate-200 rounded-tl-lg rounded-tr-lg hover:scale-110 transition-all duration-700 ease-in-out"
                />
              </div>
              <div className="flex items-center justify-between px-1 ">
                <div className="flex gap-0.5">
                  <AiFillHeart className="text-red-500 icon-style" />
                  {item.like?.substring(0, 1)}
                </div>
                <span className="flex items-center justify-center gap-0.5">
                  <AiOutlineClockCircle className="icon-style text-black text-[4px]" />
                  {item.time}
                </span>
                <span className="text-blue-600 font-bold whitespace-nowrap text-sm flex gap-0.5">
                  <AiOutlineBorderlessTable />
                  {item.by}
                </span>
              </div>
              <div className="grid items-center justify-items-start px-4">
                <p className="text-base  font-semibold lg:text-sm">
                  {item.title}
                </p>
                <p className="text-justify">{item.text}</p>
              </div>
              <div className="flex items-center justify-center px-4 w-full">
                <a
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  className="w-full bg-gradient-to-b from-slate-900 to-black shadow-md shadow-black text-center text-slate-200 button-theme"
                >
                  {item.btn}
                </a>
              </div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default TopStories;
